<template>
  <v-container fluid>
    <v-list>
      <v-list-item-group>
        <v-list-item v-for="(item, index) in items" :key="item.title" avatar :href="item.url">
          <v-list-item-content>
            <v-list-item-title v-html="item.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-container>
</template>

<script>
export default {
  name: 'FAQIndex',
  data() {
    return {
      items: [
        {
          title: 'Инструкция по сайту',
          divider: true,
          url: process.env.VUE_APP_INSTRUCTION_URL,
        },
        {
          title: 'Контакты по сайту',
          divider: true,
          url: process.env.VUE_APP_INSTRUCTION_CONTACTS_URL,
        },
      ],
    }
  },
}
</script>
